import {
  LetterbookSettingType,
  LetterbookRowComponentType,
} from "features/Letterbooks/types";
import { LetterbooksSerializersLetterbook } from "types/serializers";

interface LetterbooksCollectionOptions {
  letterbooks: LetterbooksSerializersLetterbook[];
  settings: LetterbookSettingType;
  RowComponent: LetterbookRowComponentType;
}

export default function CardCollection({
  letterbooks,
  settings,
  RowComponent,
}: LetterbooksCollectionOptions) {
  return (
    <div className="mt-4">
      {letterbooks.map((letterbook) => (
        <RowComponent
          key={`${letterbook.book.id}-${letterbook.position}`}
          letterbook={letterbook}
          settings={settings}
        />
      ))}
    </div>
  );
}
